import {
  getClientsWithEmployeesAPI,
  getClientWithEmployeesByIdAPI,
} from 'services/axios/payrollDashboard'

export const actions = {
  GET_CLIENTS_WITH_EMPLOYEES: 'GET_CLIENTS_WITH_EMPLOYEES',
  GET_CLIENT_WITH_EMPLOYEES_BY_ID: 'GET_CLIENT_WITH_EMPLOYEES_BY_ID',
  GET_CLIENTS_WITH_EMPLOYEES_ERROR: 'GET_CLIENTS_WITH_EMPLOYEES_ERROR',
}

export const getClientsWithEmployees = (filters = {}) => {
  return async (dispatch) => {
    try {
      const response = await getClientsWithEmployeesAPI(filters)
      dispatch({
        type: actions.GET_CLIENTS_WITH_EMPLOYEES,
        payload: response?.data || [],
      })
    } catch (error) {
      console.error('Error fetching clients with employees:', error)
      dispatch({
        type: actions.GET_CLIENTS_WITH_EMPLOYEES_ERROR,
        payload: error.message,
      })
    }
  }
}

export const getClientWithEmployeesById = (id, filters = {}) => {
  return async (dispatch) => {
    try {
      const response = await getClientWithEmployeesByIdAPI(id, filters)
      dispatch({
        type: actions.GET_CLIENT_WITH_EMPLOYEES_BY_ID,
        payload: response?.data,
      })
    } catch (error) {
      console.error('Error fetching client with employees by id:', error)
      dispatch({
        type: actions.GET_CLIENT_WITH_EMPLOYEES_BY_ID_ERROR,
        payload: error.message,
      })
    }
  }
}
